import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { createTripMutation } from './createTripCrudResource'

export const useDeleteExpense = createTripMutation<
    void,
    { tripId: string; expenseId: number }
>({
    mutationFn: async ({ tripId, expenseId }) => {
        await api.delete(`/trips/${tripId}/expenses/${expenseId}`)
    },
    invalidate: ({ tripId }) => [queryKeys.expenses(tripId), queryKeys.paymentsOwed(tripId)],
})
